import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (sessionId) {
        try {
          const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
          setUser(data);
        } catch {
          setUser(false);
        }
      }
      window.history.replaceState(null, '', window.location.pathname);
      navigate('/', { replace: true });
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex flex-col items-center justify-center py-40 text-[#00847A]" data-testid="auth-callback">
      <Loader2 size={40} className="animate-spin" />
      <p className="mt-4 text-[#595959]">Connexion en cours…</p>
    </div>
  );
};

export default AuthCallback;
